export default "__VITE_ASSET__ececde24__"